// @ts-nocheck

export type AdminStoriesListOrdering =
  typeof AdminStoriesListOrdering[keyof typeof AdminStoriesListOrdering];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminStoriesListOrdering = {
  "-created_at": "-created_at",
  "-status": "-status",
  "-title": "-title",
  created_at: "created_at",
  status: "status",
  title: "title",
} as const;
